import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexStyle, StyleProp } from 'react-native';

import { GameTrackerButton } from '@/components/GameTrackerButton';
import { Tooltip } from '@/components/Tooltip';
import { OneTimeShowKeys, useShowOneTime } from '@/hooks/use-show-one-time';
import { FloatingModalConfig } from '@/utils/floatingModal/FloatingModalProvider';

export const OneTimeTooltipGameTracker = ({
    gameTrackerConfig,
    screenName,
    tooltipContentPosition,
    iconColor,
}: {
    gameTrackerConfig: FloatingModalConfig;
    screenName: OneTimeShowKeys;
    tooltipContentPosition?: StyleProp<FlexStyle>;
    iconColor?: string;
}) => {
    const { t } = useTranslation();
    const { show, handleInteraction } = useShowOneTime(screenName);

    useEffect(() => {
        return () => {
            if (show) {
                handleInteraction();
            }
        };
    }, [handleInteraction, show]);

    if (!show) {
        return <GameTrackerButton iconColor={iconColor} config={gameTrackerConfig} />;
    }

    return (
        <Tooltip
            tooltipText={t('event_visualizer')}
            direction="bottom"
            initialState="visible"
            tooltipContentPosition={tooltipContentPosition ?? { right: -4, top: 32 }}
            performSideEffectOnClose={handleInteraction}
        >
            <GameTrackerButton sideEffectOnPress={handleInteraction} iconColor={iconColor} config={gameTrackerConfig} />
        </Tooltip>
    );
};
